export default "__VITE_ASSET__UmhWMWy6__"